function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 5.48438V18.6875C17.2266 19.3984 16.6523 19.9727 15.9414 19.9727H4.05859C3.34766 19.9727 2.77344 19.3984 2.77344 18.6875V1.30469C2.77344 0.59375 3.34766 0.0195312 4.05859 0.0195312H11.7617L17.2266 5.48438Z",
    fill: "#23A566",
    style: {
      fill: "#23A566",
      fill: "color(display-p3 0.1373 0.6471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1602 9.95703H6.83984C6.61328 9.95703 6.42969 10.1406 6.42969 10.3672V15.8711C6.42969 16.0977 6.61328 16.2812 6.83984 16.2812H13.1641C13.3906 16.2812 13.5742 16.0977 13.5742 15.8711V10.3711C13.5703 10.1445 13.3867 9.95703 13.1602 9.95703ZM7.25 12.5977H9.58984V13.6406H7.25V12.5977ZM10.4102 12.5977H12.75V13.6406H10.4102V12.5977ZM12.75 11.7773H10.4102V10.7813H12.75V11.7773ZM9.58984 10.7813V11.7773H7.25V10.7813H9.58984ZM7.25 14.4648H9.58984V15.4609H7.25V14.4648ZM10.4102 15.4609V14.4648H12.75V15.4609H10.4102Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M12.5 5.28906L17.2305 9.12109V5.52344L14.5469 3.96484L12.5 5.28906Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2227 5.48438H13.043C12.332 5.48438 11.7578 4.91016 11.7578 4.19922V0.0195312L17.2227 5.48438Z",
    fill: "#8ED1B1",
    style: {
      fill: "#8ED1B1",
      fill: "color(display-p3 0.5569 0.8196 0.6941)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.d0ac17dbec851cfa6f4b13d3e6450453.svg";
export { ForwardRef as ReactComponent };